import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ApiRequestOptions } from '../../../core/services/api/request-options';
import { VasBaseObjectApiFacade } from '../base-object/vas-base-object.api-facade';
import { Account } from './account.model';

export class AccountApiFacade extends VasBaseObjectApiFacade<Account> {

    get(id: string, options?: ApiRequestOptions): Observable<Account> {
        return this.GET(`/accounts/${id}`, options)
            .map(o => o ? new Account(o) : o);
    }

    getAll(options?: ApiRequestOptions): Observable<Array<Account>> {
        return this.CGET(`/accounts`, options)
            // the account CGET is a bit of a special case because the api does
            // not return a full object, so we need to go and fetch each one
            // separately
            .concatMap(list => {
                return forkJoin(...list.map(item => this.get(item.id, options)));
            })
            .map(list => list.filter(a => !!a));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account/account.api-facade.ts